type BrandLogoProps = {
  size?: "sm" | "md" | "lg";
  className?: string;
  framed?: boolean;
};

const sizeMap = {
  sm: "h-11 w-11 rounded-xl p-1.5",
  md: "h-[3.75rem] w-[3.75rem] rounded-2xl p-2",
  lg: "h-24 w-24 rounded-[1.75rem] p-3",
};

export function BrandLogo({
  size = "md",
  className = "",
  framed = true,
}: BrandLogoProps) {
  return (
    <div
      className={`${framed ? `border border-[#dce8ee] bg-[linear-gradient(180deg,rgba(252,254,255,0.98),rgba(241,247,250,0.96))] shadow-[0_12px_26px_rgba(106,138,151,0.08)] ${sizeMap[size]}` : ""} ${className}`}
    >
      <img
        src="/qiandu-logo.jpg"
        alt="QIANDU logo"
        className="h-full w-full object-contain"
      />
    </div>
  );
}
